import React, { FC } from 'react';
import styled from 'styled-components';
import { theme } from 'theme';

const letters =
  'bHzUyQwLtNxJfKmZqLxPyCvOaDdBeFsRhPgWaKiJvVoLlXpAmHtFqGnEpXwZjRsYvUcMpCnVtGzEoSdFkTlWyUqJoBkP';

export const BlurredText = styled.div`
  user-select: none;
  filter: ${`blur(${theme.spacing(0.75)})`};
`;

export type BlurProps = {
  length?: number;
};

export const Blur: FC<BlurProps> = ({ length = 10 }) => (
  <BlurredText>{letters.slice(0, length)}</BlurredText>
);
